// extracted by mini-css-extract-plugin
export default {"__label":"Options___label__AsH4C","row":"Options_row__i6iaJ","row__button":"Options_row__button__lHSaJ"};